function CloseButton({onClick})
{
    return <div className="bulletButton" onClick={onClick}>
        <img src={'/media/images/icons/closeIcon.png'} alt={'icon'}/>
    </div>
}

export default CloseButton